/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum JobRequestType {
    TRANSLATION_REQUEST = 'TRANSLATION_REQUEST',
    QUOTE_REQUEST = 'QUOTE_REQUEST',
    POST_EDIT_REQUEST = 'POST_EDIT_REQUEST',
    ADD_WATERMARK_REQUEST = 'ADD_WATERMARK_REQUEST',
    JUNK_REQUEST = 'JUNK_REQUEST',
    OTHER_REQUEST = 'OTHER_REQUEST',
}
